import React from "react";
import PropTypes from "prop-types";

import Slider from "react-slick";

class DialogueSlider extends React.Component {
    state = {
        activeSlide: 0
    };

    render() {
        const settings = {
            dots: true,
            infinite: true,
            arrows: false,
            slidesToShow: 3,
            slidesToScroll: 0,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        arrows: false,
                        autoplay: true,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        infinite: true,
                        dots: true,
                        speed: 500,
                        dotsClass: "slider-nav",
                        beforeChange: (current, next) =>
                            this.setState({ activeSlide: next }),
                        appendDots: dots => {
                            return (
                                <div>
                                    <span className="slider-nav__numbers">
                                        {this.state.activeSlide + 1} of{" "}
                                        {dots.length}
                                    </span>
                                    <ul className="slider-nav__list">{dots}</ul>
                                </div>
                            );
                        },
                        customPaging: i => (
                            <span className="slider-nav__list-dot" />
                        )
                    }
                }
            ]
        };

        return (
            <div className="dialogue-boxes">
                <Slider {...settings}>{this.props.children}</Slider>
            </div>
        );
    }
}

DialogueSlider.propTypes = {
    children: PropTypes.array.isRequired
};

export default DialogueSlider;



// WEBPACK FOOTER //
// ./src/components/landingPage/DialogueSlider.jsx